import { TextField } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import useStyles from 'features/Filters/SpaceIdsInput/SpaceIdsInput.styles';
import { Filters } from 'features/Filters/types/Filters';
import { setErrorMessagesForIds } from 'features/Filters/utils/setErrorMessageForIds';

type spaceIdsInputProps = {
  options: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filterKey: string;
};

const SpaceIdsInput = ({ options, setSelectedFilters, filterKey }: spaceIdsInputProps) => {
  const classes = useStyles();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const onChangeAndPaste = (event: React.ChangeEvent<HTMLInputElement>) => {
    const typedOrPastedValue = event.target.value;
    const newValues = setErrorMessagesForIds(typedOrPastedValue, setErrorMessage, options);

    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey as keyof Filters]: newValues,
    }));
  };

  return (
    <TextField
      className={classes.spaceIdsTextBox}
      data-testid="spaceIdsInput"
      label="Space IDs"
      onChange={onChangeAndPaste}
      error={!!errorMessage}
      helperText={
        errorMessage && (
          <span
            id="errorMessage"
            data-testid="errorMessage"
            style={{ whiteSpace: 'pre-wrap', fontWeight: 'bold', fontSize: '14px' }}
          >
            {errorMessage}
          </span>
        )
      }
      placeholder="123456789, 234567891, 3455678912"
    />
  );
};

export default SpaceIdsInput;
